import styled from "styled-components";

export const MainStyled = styled.main`
    display: flex;
    gap: 72px;
    flex-direction: column;
`;